module.exports = __webpack_public_path__ + "img/20220312_145130.f43c179c.jpg";